import Component from "../../../classes/Component";
import {$events} from "../../../helpers/events";
import variables from "../../../variables";
import gsap from "gsap";
import {animationTargetAttr, defaultDuration, getAnimation, animationShift, initSectionsAnimations} from "./helpers";
import ScrollTrigger from 'gsap/ScrollTrigger';
import {$dom} from "../../../helpers/dom";

gsap.registerPlugin(ScrollTrigger);

const {customEventNames} = variables;

gsap.defaults({duration: defaultDuration, ease: 'power2.out'});

export default function (animationList = []) {
    const $Page = this;
    return new Component({
        name: 'animationCommon',
        requiredTargets: `[${animationTargetAttr}]`,
        onInit() {
            this.introBgSelector = getAnimation({name: 'intro-bg'}).element;
            this.introTimeline = gsap.timeline();
            let headerAlreadyAnimated = false;

            this.checkScroll = () => {
                const introBgElem = getAnimation({name: 'intro-bg', returnSelector: false}).element;

                if ($dom.hasClass($Page.rootEl, 'immediate-header-animation')) {
                    gsap.fromTo(getAnimation({name: 'header'}).element, {
                        yPercent: -animationShift,
                        autoAlpha: 0
                    }, {
                        yPercent: 0,
                        autoAlpha: 1
                    });
                    headerAlreadyAnimated = true;
                    return;
                }

                if (Boolean(introBgElem) && window.scrollY > introBgElem.offsetHeight && !headerAlreadyAnimated) {
                    gsap.fromTo(getAnimation({name: 'header'}).element, {
                        yPercent: -animationShift,
                        autoAlpha: 0
                    }, {
                        yPercent: 0,
                        autoAlpha: 1
                    });
                    headerAlreadyAnimated = true;
                }
            }

            this.handleIntroBgLoaded = () => {
                const {element: introProductSelector} = getAnimation({name: 'intro-product', returnSelector: true});

                this.introTimeline
                    .to(this.introBgSelector, {autoAlpha: 1})
                    .addLabel('header-in')
                    .fromTo(getAnimation({name: 'intro-title'}).element, {
                        xPercent: -25,
                        autoAlpha: 0
                    }, {
                        xPercent: 0,
                        autoAlpha: 1,
                        stagger: .15
                    });

                if ($dom.exist(introProductSelector)) {
                    this.introTimeline
                        .fromTo(introProductSelector, {
                            yPercent: 20,
                            autoAlpha: 0
                        }, {
                            yPercent: 0,
                            autoAlpha: 1,
                            duration: defaultDuration * 2,
                        });
                }

                if (!headerAlreadyAnimated) {
                    this.introTimeline.add(gsap.fromTo(getAnimation({name: 'header'}).element, {
                        yPercent: -animationShift,
                        autoAlpha: 0
                    }, {
                        yPercent: 0,
                        autoAlpha: 1
                    }), 'header-in');

                    headerAlreadyAnimated = true;
                }
            };

            this.checkScroll();
            initSectionsAnimations(animationList);

            $events.delegate
                .on(customEventNames.lazyImageLoaded, this.introBgSelector, this.handleIntroBgLoaded)
        },
        onDestroy() {
            $events.delegate
                .off(customEventNames.lazyImageLoaded, this.introBgSelector, this.handleIntroBgLoaded)
        }
    })
}
